import { PluginConfigParam } from '@air/sanity-constants';

const STORAGE_KEY_HOST_ORIGIN = 'air:hostOrigin';
const STORAGE_KEY_PROJECT_ID = 'air:projectId';
const STORAGE_KEY_WORKSPACE_ID = 'air:workspaceId';

/** Persists workspaceId, hostOrigin, and projectId to sessionStorage. Called once on initial load. */
export function persistPluginParams(searchParams: URLSearchParams): void {
  try {
    const hostOrigin = searchParams.get(PluginConfigParam.HostOrigin);
    const projectId = searchParams.get(PluginConfigParam.ProjectId);
    const workspaceId = searchParams.get(PluginConfigParam.WorkspaceId);
    if (hostOrigin) sessionStorage.setItem(STORAGE_KEY_HOST_ORIGIN, hostOrigin);
    if (projectId) sessionStorage.setItem(STORAGE_KEY_PROJECT_ID, projectId);
    if (workspaceId) sessionStorage.setItem(STORAGE_KEY_WORKSPACE_ID, workspaceId);
  } catch {
    // sessionStorage unavailable (e.g., restricted iframe context)
  }
}

/** Reads persisted plugin params from sessionStorage. */
export function getPersistedPluginParams(): { hostOrigin?: string; projectId?: string; workspaceId?: string } {
  try {
    return {
      hostOrigin: sessionStorage.getItem(STORAGE_KEY_HOST_ORIGIN) ?? undefined,
      projectId: sessionStorage.getItem(STORAGE_KEY_PROJECT_ID) ?? undefined,
      workspaceId: sessionStorage.getItem(STORAGE_KEY_WORKSPACE_ID) ?? undefined,
    };
  } catch {
    return {};
  }
}
